import axios from 'axios'
import store from 'store'
import { notification } from 'antd'
import { firebaseAuth } from 'services/firebase'

const { REACT_APP_API_URL } = process.env

const apiClient = axios.create({
  baseURL: `${REACT_APP_API_URL}`,
  // timeout: 1000,
  // headers: { 'X-Custom-Header': 'foobar' }
})

// firebaseAuth.signOut().then(() => {
//   store.remove('accessToken')
//   return true
// })

apiClient.interceptors.request.use(async request => {
  if (firebaseAuth.currentUser === null || request.url === '/auth/local') {
    return request
  }
  const accessToken = store.get('accessToken')
  request.headers.Authorization = `Bearer ${accessToken}`

  return request
})

apiClient.interceptors.response.use(
  res => res,
  error => {
    // Error handling
    const { response } = error
    if (!response) {
      notification.error({
        message: 'Error!',
        description:
          'An error occured while sending your request. Please check your internet connection',
      })
      return response
    }
    const { message } = response.data

    // if (response.status === 422) {
    //   let fields = []
    //   if (errors && Array.isArray(errors)) {
    //     fields = errors.map(errorItem => {
    //       return { name: errorItem.name, errors: [errorItem.message] }
    //     })
    //   }
    //   response.errorFields = fields

    //   notification.error({
    //     message: 'Failed!',
    //     description: 'Input validation failed',
    //   })
    //   return response
    // }

    if (response.status === 403) {
      return notification.error({
        message: 'Forbidden!',
        description: 'You are not allowed to perform this action.',
      })
    }
    if (message && Array.isArray(message) && Array.isArray(message[0].messages)) {
      const textMessage = message[0].messages[0].message
      notification.error({
        message: 'Failed!',
        description: textMessage,
      })
      return null
    }
    notification.warning({
      message: 'An error occured while sending your request. Please try again',
    })
    return null
  },
)

export default apiClient
